export  let cookieTypes = ['adform', 'ar', 'mobile', 'ip',  'sirdata', 'weborama', 'tdd', 'ID5'];
